import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Typography,
  MenuItem,
  Button,
  IconButton,
  InputAdornment,
  Select,
  Chip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import contries from "../Roles and Permissions/Country.json";
import SelectField from "../../../Components/Masters/SelectField";
import axios from "axios";
import { api, get, post, put } from "../../../utils/api";
import { useUser } from "../../../context/AuthContext";
import PhoneInput from "../../../Components/Masters/PhoneInput";
import { validateNumber } from "../../../utils/validateFields";
import EmailField from "../../../Components/Masters/EmailField";
import PhoneInputField from "../../../Components/Masters/PhoneInputField";
import EditDialog from "../../../Components/Common/EditDialog";

const moduleName = [
  "Select All",
  "Environment | Scope 1 ",
  "Environment | Scope 2",
  "Environment | Scope 3",
  "Environment Dashboard",
  "Social Dashboard",
  "Governance Dashboard",
  "MIS Report",
  "Setup",
  "Roles & Permission",
  "Masters",
  "ESG Reporting",
  "GRI",
  "BRSR",
  "CDP",
  "Value Chain",
  "Water Management",
  "Documentation",
];
const moduleNames = [
  "Select All",
  "Environment | Scope 1 | Stationary Combustion",
  "Environment | Scope 1 | Mobile Combustion",
  "Environment | Scope 1 | Fugitive Emissions",
  "Environment | Scope 2 | Electricity",
  "Environment | Scope 2 | Heating / Cooling",
  "Environment | Scope 2 | Steam",
  "Environment | Scope 3 | Purchased",
  "Environment | Scope 3 | Transportation",
  "Environment | Scope 3 | Employee",
  "Environment | Scope 3 | Business travel",
  "Environment | Scope 3 | Waste gen",
  "Water management",
  "Social",
  "Governance",
  "ESG Reporting |BRSR",
  "ESG Reporting | GRI",
  "Value Chain Partner",
  "Environment Dashboard",
  "Social Dashboard",
  "Governance Dashboard",
  "MIS Report",
  "Setup",
  "Roles & Permission",
  "Masters",
  "ESG Reporting",
  "GRI",
  "BRSR",
  "CDP",
  "Value Chain",
  "Water Management",
  "Documentation",
];
function AddAdmin(props) {
  const { user } = useUser();
  const [facilities, setFacility] = useState(["Tap to Select"]);
  const [roles, setRole] = useState(["Tap to Select"]);
  const [updatedRoles, setUpdatedRoles] = useState(["Tap to Select"]);
  const [FunctionalityRole, setFunctinalityRole] = useState([]);
  const [alreadyUser, setAlreadyUser] = useState(false);
  const [selectedEmail, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [verifybtn, setverifybtn] = useState({ email: false, phone: false });
  const [verify, setVerify] = useState({
    phone: false,
    mail: false,
    emailMsg: "",
    phoneMsg: "",
  });
  const [TaskAltIcons, setTaskAltIcons] = useState({
    email: false,
    phone: false,
  });
  // Time state

  const [otp, setOTP] = useState({
    phone: null,
    email: null,
  });

  const initialState = {
    country: "",
    companyName: "",
    name: "",
    email: "",
    phone: "",
    countryCode: "",
  };

  const [fromValue, setFromValue] = useState(initialState);
  const [fromValue2, setFromValue2] = useState(initialState);

  const [time, setTime] = useState(120); // Initialize time to 2 minutes (120 seconds)
  const [timerPhone, setTimerPhone] = useState(120);
  const [editDialog, setEditDialog] = useState(false);

  const handleClose = () => {
    const isFormDataUnchanged = Object.keys(fromValue).every(
      (key) => fromValue[key] === fromValue2[key]
    );

    if (isFormDataUnchanged) {
      handleExitAgree();
    } else {
      setEditDialog(true);
    }
  };

  const handleExitAgree = () => {
    console.log("hiii");
    props.setValue(false);
    setEditDialog(false);
    setverifybtn({ phone: false, email: false });
    setVerify({ phone: false, email: false, emailMsg: "", phoneMsg: "" });
    setTaskAltIcons({ phone: false, email: false });
    resetForm();
    // }
  };
  const resetForm = () => {
    setTaskAltIcons({
      email: false,
      phone: false,
    });
    setOTP({
      phone: null,
      email: null,
    });
    setVerify({
      phone: false,
      mail: false,
    });
    setverifybtn({ email: false, phone: false });
    setEmail(props.index === 0 ? "" : props.index?.email);
    setState();
    setErrors({});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value, "forUpdate");
    setFromValue({
      ...fromValue,
      [name]: value,
    });
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  useEffect(() => {
    const fetchData = async (url) => {
      try {
        const response = await get(url);
        return response;
      } catch (err) {
        console.error(`Error fetching data from ${url}:`, err);
      }
    };

    fetchData(`/auth/FetchUserRoles`).then((res) => {
      if (res) {
        console.log(res.data.data, "datafacility");
        setFunctinalityRole(res.data.data);
        setRole(res.data.data);
      }
    });

    fetchData(`/master/getAllFacility`).then((res) => {
      if (res) {
        console.log(res.data.data, "resfacility");
        setFacility(res.data.data);
      }
    });
  }, [props.index]);
  const handleEmailChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = value.trim();
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    setTaskAltIcons((prevState) => ({ ...prevState, email: false }));
    setVerify((prevState) => ({ ...prevState, email: false, emailMsg: "" }));
    setverifybtn((prevState) => ({ ...prevState, email: false }));
    // setTimerEmail(120);

    setErrors((prevState) => ({
      ...prevState,
      email: "",
    }));
    setOTP((prevState) => ({
      ...prevState,
      email: "", // Update the OTP value
    }));

    setFromValue((prevState) => ({
      ...prevState,
      [name]: trimmedValue,
    }));

    // if (element?.email === formData.email) {
    //   setTaskAltIcons((prev) => ({ ...prev, email: true }));
    //   return;
    // }
   
  };
  useEffect(() => {
    let filteredRoles = roles.filter(
      (role) =>
        role?.facility ===
        (user?.companyAdmin ? fromValue?.facility : user?.facility?._id)
    );
    setUpdatedRoles(filteredRoles);
  }, [fromValue?.facility, roles]);

  const setState = () => {
    if (props.index !== 0) {
      const state = {
        companyName: user?.company?.companyName ?? "",
        country: props.index?.country ?? "Select Country",
        email: props.index?.email ?? "",
        name: props.index?.name ?? "",
        phone: props.index?.phone ?? "",
        countryCode: props.index?.countryCode ?? "",
        
      };
      setFromValue(state);
      setFromValue2(state);
      setEmail(props.index?.email);
      setAlreadyUser(true);
      setTaskAltIcons({ ...TaskAltIcons, email: true });
    } else {
      const state = {
        companyName: user?.company?.companyName ?? "",
        country: "",
        email: "",
        name: "",
        phone: "",
        countryCode: "",
      };
      setFromValue(state);
      setFromValue2(state);
      setTaskAltIcons({ ...TaskAltIcons, email: false });

      setEmail("");
      setAlreadyUser(false);
    }
  };

  useEffect(() => {
    setState();
  }, [props.index, FunctionalityRole]); // Add necessary dependencies

  const Submit = async () => {
    if (!validateForm()) return;
    const keysToRemove = ["role", "createdBy"];

    const data = Object.fromEntries(
      Object.entries(fromValue).filter(
        ([key, value]) =>
          !(
            keysToRemove.includes(key) &&
            (value === "" || value === "undefined" || value === null)
          )
      )
    );

    try {
      const url = alreadyUser
        ? `/api/company/updateCompanyAdmin?Id=${props.index?._id}`
        : `/api/company/createComapanyAdmin`;

      const method = alreadyUser ? put : post;
      const response = await method(url, data);

      props.setValue(false);
      props.fetchUsers();
      resetForm();
      props.setsnackOpen({
        open: true,
        message: response.data.message,
        severity: "success",
      });
    } catch (err) {
      console.log(err?.response.data.errors,"for error")
      if (err?.response?.data?.message === "Email Already exists.") {
        setErrors({ ...errors, email: err?.response?.data?.message });
      } else {
        props.setsnackOpen({
          open: true,
          message: err?.response?.data?.msg ||
          err?.response?.data?.errors[0]?.msg || "An error occurred",
          severity: "error",
        });
      }
    }
  };

  console.log("first123", errors);

  const validateForm = () => {
    const newErrors = {};
    const {
      companyName,
      country,
   
      name,
      email,
      phone,
      
    } = fromValue;

    // Validate `company`
    if (!companyName || companyName.trim() === "") {
      newErrors.companyName = "Company is required.";
    }

    // Validate `country`
    if (!country || country === "Tap to select") {
      newErrors.country = "Please select a country.";
    }

    // Validate `facility`

    // Validate `name`
    if (!name || name.trim() === "") {
      newErrors.name = "Name is required.";
    }

    // Validate `email`
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = "A valid email is required.";
    }

    if (verifybtn.email === true && email) {
      newErrors.email = "Please validate your email.";
    }

    console.log(typeof phone, "p11", phone);
    // Validate `phone` and `countryCode`
    if (phone) {
      // If phone number is present but countryCode is missing
      if (!validateNumber(phone) || phone?.length < 7) {
        newErrors.phone = "Please enter valid Mobile Number"; // Validates phone number format
      }
    }

    if (phone === "") newErrors.phone = `Mobile No. is required`;
    // if (!validateNumber(phone) || phone.length !== 10)
    //   newErrors.phone = "Please enter 10 digit Mobile Number";
    // Set the error message for mobileNo
    // else if (errors.phone) return;
    // else if (verify.phone) {
    //   setVerify({
    //     ...verify,
    //     phoneMsg: verify.phoneMsg || "OTP is required",
    //   });
    //   newErrors["mblOtp"] = "OTP is required";
    // } else if (!TaskAltIcons.phone)
    //   newErrors["phone"] =
    //     errors.phone || "Contact Number Verification required"; // Set the error message for mobileNo

    if (email === "") newErrors["email"] = `Email is required`;
    // else if (errors.email) return;
    if (verify.email) {
      newErrors["emailOtp"] = "OTP is required";
      setVerify({
        ...verify,
        phoneMsg: verify.phoneMsg || "OTP is required",
        emailMsg: verify.emailMsg || "OTP is required",
      });
    } 
   
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCountryChange = (event) => {
    console.log("event.target.value", event.target.value);
    const selectedCountryCode = event.target.value;
    const selectedCountry = contries.countries.find(
      (country) => country.name === selectedCountryCode
    ); // Find the selected country object

    if (selectedCountry) {
      setFromValue({
        ...fromValue,
        country: selectedCountry.name, // Set country name
        countryCode: selectedCountry.dial_code, // Set country code
      });

      setErrors((prev) => ({ ...prev, country: "" }));

      if (errors.phone === "Please Select Country")
        setErrors({ ...errors, phone: "" });

      if (selectedCountry.dial_code && fromValue.phone !== "") {
        console.log(fromValue.phone, "fromValue.phone");
        setVerify({ ...verify, phone: true });
        setErrors({ ...errors, phone: "" });
      }
    }
  };

  const list = (anchor) => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.6rem",
        // maxWidth:"100%",
        height: "100vh",
        display: "flex",
        justifyContent: "space-btween",
        backgroundColor: "transparent",
      }}
    >
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          padding: "24px",
          backgroundColor: "#fff",
          height: "100%",
          width: "100%",
          overflowY: "scroll",
        }}
      >
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {props.index !== 0 ? "Edit User" : "Add New User"}
        </Typography>

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Company Name
        </Typography>
        <CustomTextField
          variant="outlined"
          value={fromValue.companyName}
          fullWidth
          name="companyName"
          placeholder="Prefilled"
          InputProps={{
            readOnly: true, // Makes the field read-only
          }}
          error={!!errors.companyName} // Show error styling if there's an error
          InputLabelProps={{
            style: { color: errors.companyName ? "#D34040" : undefined },
          }}
          disabled
        />
        {errors.companyName && (
          <Typography variant="body2" color="#D34040">
            {errors.companyName}
          </Typography>
        )}
        <SelectField
          title={"Country"}
          name={"country"}
          value={fromValue.country}
          handleChange={handleCountryChange}
          options={contries.countries}
          errors={errors["country"]}
          //   url={el.url}
        />
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Nickname
        </Typography>
        <CustomTextField
          variant="outlined"
          value={fromValue.name}
          onChange={handleChange}
          fullWidth
          name="name"
          placeholder="Enter Name"
          error={!!errors.name}
          InputLabelProps={{
            style: { color: errors.name ? "#D34040" : undefined },
          }}
        />
        {errors.name && (
          <Typography variant="body2" color="#D34040">
            {errors.name}
          </Typography>
        )}
        <PhoneInputField
          value={fromValue?.phone || ""} // Use optional chaining
          errors={errors["phone"]}
          fieldName={"phone"}
          placeholder="Enter Mobile No"
          title="Mobile No."
          {...{
            setErrors,
            setFormData: setFromValue,
            formData: fromValue,
          }}
          countryCode={fromValue?.countryCode || ""} // Use optional chaining
        />

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Email ID
        </Typography>
        <Box
          sx={{
            display: `${TaskAltIcons.email === true ? "flex" : "block"}`,
            width: `${TaskAltIcons.email === true ? "100%" : "100%"}`,
          }}
        >
          <CustomTextField
            variant="outlined"
            value={fromValue.email}
            onChange={handleEmailChange}
            fullWidth
            name="email"
            placeholder="Enter Email"
            error={!!errors.email} // Show error styling if there's an error
            InputLabelProps={{
              style: { color: errors.email ? "#D34040" : undefined },
            }}
            InputProps={{
              endAdornment: TaskAltIcons.email && (
                <TaskAltIcon sx={{ color: "green", textAlign: "right" }} />
              ),
            }}
          />
        </Box>
        {errors.email && (
          <Typography variant="body2" color="#D34040">
            {errors.email}
          </Typography>
        )}
        <Box>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Submit}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <div>
      <Drawer
        sx={{
          width: "100%",
          backgroundColor: "transparent",
          "& .MuiDrawer-paper": {
            // This targets the paper component within the Drawer
            backgroundColor: "transparent", // Make paper transparent
            boxShadow: "none", // Optional: Remove any shadow
          },
        }}
        anchor="right"
        open={props.value}
        onClose={handleClose}
      >
        {list()}
      </Drawer>
    </div>
  );
}
export default AddAdmin;

//// custom textfield

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px", // Adjust height as needed
  },
  "& .MuiSelect-select": {
    height: "56px", // Adjust height as needed
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
}));
